import { BASEURL, IMGBASEURL } from "@/config/index";

export default {
    imageBaseURL: BASEURL,
    imageS3BaseURL: !!IMGBASEURL ? IMGBASEURL : "https://images.brijimages.com/",

    movieImages: {
        moviesUploadThumbnailImage: "280*350",
    },
    dateFormat: "dd MMM yyyy",
    cookiekeys: {
        BRHSID: 'BRHSID'
    }
}



// WEBPACK FOOTER //
// ./src/helper/constant.js